import styled from "styled-components";
import { breakpoints } from "@/shared/Constants";

export const MainTitle = styled.h1`
  text-indent: -999em;
  opacity: 0;
  transform: scale(0);
  height: 1px;
`;

export const HeaderVintageContainer = styled.div`
  .home-vintage,
  .sticky {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    animation: none;
    height: 100px;
    z-index: 9999;
    ${breakpoints.phone} {
      height: 60px;
    }
    .container-vintage {
      width: 100% !important;
      height: 100px !important;
      ${breakpoints.phone} {
        height: 60px !important;
      }
    }
    .logo-header img {
      width: 170px;
      ${breakpoints.phone} {
        width: 115px;
      }
    }
  }
`;
